<!-- eslint-disable max-len -->
<template>
  <div class="d-flex flex-column">
    <!-- Screen Mode & Save -->
    <div
      :class="{ 'screen-mode-and-save-scroll': isScroll }"
      class="screen-mode-and-save justify-content-end"
    >
      <div class="wrap-screen-mode justify-content-end">
        <button
          class="save-button"
          @click="submitForm">
          Save
        </button>
      </div>
    </div>

    <!-- Card Page -->
    <div class="card-page">
      <!-- Button Properties setup view -->
      <div
        class="icon-setup-view"
        @click="openConfiguration"
      >
        <img
          src="@/assets/new-form-ui/setup.svg"
        >
      </div>

      <div class="card-page-content input-field">
        <!-- Section Information -->
        <div class="section">
          <h6 class="card-title-text">View Information</h6>

          <b-form :class="{'error-input' : $v.dataSetup.title.$error}">
            <label>Title <span style="color:red">*</span></label>
            <j-input
              v-model="dataSetup.title"
              placeholder="Enter title here"
            />
          </b-form>
          <b-form
            v-if="isExternalApi"
            :class="{'error-input' : $v.dataSetup.sheet_name.$error}"
          >
            <label>Sheet Name</label>
            <j-input
              v-model="dataSetup.sheet_name"
              placeholder="Enter sheet name here"
            />
          </b-form>
          <b-form v-if="!dataSetup.is_use_advance_report || isDatasetSource">
            <label>Format File</label>
            <j-single-select
              v-model="$v.dataSetup.format_file.$model"
              :options="isDatasetSource ? listFormatFileAdvanceReport : listFormatFile"
              :disabled="isDatasetSource"
              placeholder="Select Format File"
            />
          </b-form>
        </div>

        <!-- Section Sheet -->
        <div
          v-if="!isExternalApi"
          class="section"
        >
          <h6 class="card-title-text mb-2">Sheet</h6>

          <div
            v-if="!isLoading"
            class="wrap-column"
          >
            <!-- Sheet Block -->
            <draggable
              v-model="dataSetup.sheet"
              :options="{
                animation:300,
              }"
              class="d-flex align-items-center"
            >
              <div
                v-for="(data, index) in dataSetup.sheet"
                :key="index"
                class="column-block"
              >
                <div class="column-name">
                  {{ data.sheet_name }}
                </div>

                <!-- Edit or Delete -->
                <div class="edit-or-delete">
                  <div class="button">
                    <!-- Edit -->
                    <div
                      class="edit"
                      @click="openConfigSheet(data, index)"
                    >
                      <i class="fa fa-pencil-square-o" />
                      <div class="tooltip-component">Edit sheet</div>
                    </div>
                    <!-- Delete -->
                    <div
                      class="delete"
                      @click="deleteSheet(index)"
                    >
                      <i class="fa fa-trash" />
                      <div class="tooltip-component">Delete sheet</div>
                    </div>
                  </div>
                </div>
              </div>
            </draggable>

            <!-- Add Sheet -->
            <div
              class="btn-add-column"
              @click="openConfigSheet(null, null)"
            >
              <img
                :src="require('@/assets/icon/add.png')"
                class="m__r--5"
                height="15"
                width="15">
              Add Sheet
            </div>
          </div>

          <j-skeleton-sheet v-if="isLoading" />
        </div>

        <!-- Section Column -->
        <div
          v-if="isExternalApi"
          class="section"
        >
          <h6 class="card-title-text mb-2">Column</h6>

          <div
            v-if="!isLoading"
            class="wrap-column"
          >
            <!-- Column Block -->
            <draggable
              v-model="dataSetup.column"
              :options="{
                animation:300,
              }"
              class="d-flex align-items-center"
            >
              <div
                v-for="(data, index) in dataSetup.column"
                :key="index"
                class="column-block"
              >
                <img
                  :src="require(`@/assets/icon/column-type/${setIconType(data.type)}.svg`)"
                  :alt="`${data.name}-block`"
                >
                <div class="separator" />
                <div class="column-name">
                  {{ data.name }}
                </div>

                <!-- Edit or Delete -->
                <div class="edit-or-delete">
                  <div class="button">
                    <!-- Edit -->
                    <div
                      class="edit"
                      @click="openConfigColumn(data, index)"
                    >
                      <i class="fa fa-pencil-square-o" />
                      <div class="tooltip-component">Edit column</div>
                    </div>
                    <!-- Delete -->
                    <div
                      class="delete"
                      @click="deleteColumn(index)"
                    >
                      <i class="fa fa-trash" />
                      <div class="tooltip-component">Delete column</div>
                    </div>
                  </div>
                </div>
              </div>
            </draggable>

            <!-- Add Column -->
            <div
              class="btn-add-column"
              @click="openConfigColumn(null, null)"
            >
              <img
                :src="require('@/assets/icon/add.png')"
                class="m__r--5"
                height="15"
                width="15">
              Add Column
            </div>
          </div>

          <j-skeleton-sheet v-if="isLoading" />
        </div>
      </div>
    </div>

    <!-- Card Advance Report -->
    <div
      v-if="advanceReportSetting && !isExternalApi && !isDatasetSource"
      class="card-page m__t--25"
    >
      <div class="card-page-content input-field">
        <h6 class="card-title-text">Advance Report</h6>

        <div class="card-toggle-config">
          <div class="d-flex align-items-center justify-content-between">
            <div>
              <h4 class="title-config">Advance Export</h4>
              <p class="description mb-0">
                Support for exporting big data to table Data Manager and including monitoring reports
              </p>
            </div>
            <j-toggle
              v-model="dataSetup.is_use_advance_report"
              class="fix-position-toggle"
            />
          </div>
        </div>

        <b-form
          v-if="dataSetup.is_use_advance_report"
          class="mt-3"
        >
          <label>Format File</label>
          <j-single-select
            v-model="$v.dataSetup.format_file.$model"
            :disabled="true"
            :options="listFormatFileAdvanceReport"
            :error-required="false"
            placeholder="Select Format File"
          />
        </b-form>
      </div>
    </div>

    <!-- Configuration -->
    <export-view-configuration
      v-if="isOpenConfiguration"
      :id="idConfiguration"
      :data-config="dataSetup"
      :list-function="listFunction"
      :variables="variableOptions"
      :variable-options="variableOptionsClass"
      :is-have-configuration="isHaveConfiguration"
      @delete-view="deleteView"
      @close-configuration="toggleConfiguration(false)"
      @submit="submitConfig"
    />

    <!-- Configuration Sheet -->
    <sheet-configuration
      v-if="isOpenSheetConfiguration"
      :id="idConfigurationSheet"
      :field-detail="selectedSheet"
      :first-sheet="isFirstSheet"
      :variable-columns="variableOptionsSheet"
      :variable-custom-columns="variableCustomOptions"
      :is-dataset-source="isDatasetSource"
      @delete-sheet="deleteSheet"
      @close-configuration="toggleSheetConfiguration(false)"
      @submit-configuration="submitSheet"
    />

    <!-- Configuration Column -->
    <column-configuration
      v-if="isOpenConfigColumn"
      :id="idConfigColumn"
      :field-detail="selectedColumn"
      :select-variable="variableOptionsColumn"
      :type="`export`"
      @delete-configuration="deleteColumn"
      @close-configuration="toggleConfigurationColumn(false)"
      @submit-configuration="submitColumn"
    />

    <!-- Modal Field Library -->
    <modal-field-library
      v-if="showModalFieldLibrary"
      @close-modal="closeModalFieldLibrary"
    />

    <!-- Modal External Api -->
    <b-modal
      ref="modalExternalApi"
      :hide-header="true"
      :hide-footer="true"
      class="modal-external-api"
      no-close-on-backdrop
      no-close-on-esc
    >
      <modal-external-api-field
        v-if="showModalExternalUrl"
      />
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable max-len, no-unused-vars, no-nested-ternary, camelcase, no-console */
import { required } from 'vuelidate/lib/validators';
import { mapActions, mapState, mapMutations } from 'vuex';
import draggable from 'vuedraggable';
import jwtDecode from 'jwt-decode';
// Mixins
import jMixScroll from '@/mixins/form-ui-v2/jMixScroll';
import jMixToolbox from '@/mixins/form-ui-v2/jMixToolbox';
import jMixSetupColumn from '@/mixins/form-ui-v2/jMixSetupColumn';
// Components
import jSkeletonSheet from '@/views/experience-manager-v2/loading/jSkeletonSheet';
import ExportViewConfiguration from '@/views/experience-manager-v2/partials/configuration/ExportViewConfiguration';
import ModalFieldLibrary from '@/views/experience-manager-v2/popup/ModalFieldLibrary';
import ModalExternalApiField from '@/views/experience-manager-v2/popup/ModalExternalApiField';
import ColumnConfiguration from '@/views/experience-manager-v2/partials/configuration/ColumnConfiguration';
import SheetConfiguration from '@/views/experience-manager-v2/partials/configuration/SheetConfiguration';

export default {
  components: {
    draggable,
    ColumnConfiguration,
    SheetConfiguration,
    ModalFieldLibrary,
    ModalExternalApiField,
    jSkeletonSheet,
    ExportViewConfiguration,
  },

  mixins: [jMixScroll, jMixToolbox, jMixSetupColumn],

  props: {
    formDetail: {
      type: Object,
      default: () => {},
    },
    isMultipleForm: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isLoading: true,
      advanceReportSetting: false,
      dataSetup: {
        title: null,
        sheet_name: '',
        format_file: null,
        column: [],
        sheet: [],
        filter: [
          {
            key: null,
            value: null,
          },
        ],
        filter_function: [
          {
            key: null,
            value: null,
          },
        ],
        filterOperator: null,
        search_options_list: [],
        is_use_advance_report: false,
        rows_page_default: 10,
        rows_page_option: [10, 20, 50, 100],
        freeze_header_table: false,
      },
      listFormatFile: [
        { id: 'xls', text: 'XLS' },
        { id: 'xlsx', text: 'XLSX' },
      ],
      listFormatFileAdvanceReport: [
        { id: 'csv', text: 'CSV' },
      ],
      variableOptions: [],
      variableOptionsClass: [],
      variableOptionsColumn: [],
      variableOptionsSheet: [],
      variableCustomOptions: [],
      listFunction: [],
      detailDataset: null,

      // Configuration
      isFirstSheet: false,
      showModalExternalUrl: false,
      isOpenConfiguration: false,
      isOpenSheetConfiguration: false,
      isOpenModalField: false,
      idConfiguration: 'exportConfiguration',
      idConfigurationSheet: 'sheetConfiguration',
      idModalFieldLibrary: 'modalFieldLibrary',
      selectedSheet: null,
      selectedIndexSheet: null,

      isError: false,
      session: jwtDecode(JSON.parse(localStorage.getItem('Token')).value),
    };
  },

  computed: {
    ...mapState('jStoreFormUi', ['form_data_detail']),
    ...mapState('jStoreExperienceManagerV2', ['showModalFieldLibrary', 'isShowModalFieldFromGroup', 'showModalExternalApi']),

    isExternalApi() {
      return this.formDetail.type === 'external_url';
    },

    genData() {
      const { title, sheet_name, format_file, column, sheet, filter, filter_function,
        filterOperator, search_options_list, is_use_advance_report, rows_page_default, rows_page_option, freeze_header_table } = this.dataSetup;

      const params = this._.cloneDeep(this.formDetail);
      params.export_view = {
        title,
        sheet_name,
        format_file,
        columns: column,
        sheet,
        filter: {},
        filter_function: {},
        filter_operator: filterOperator,
        search_options_list: search_options_list.length > 0 ? search_options_list : null,
        is_use_advance_report,
        rows_page_default,
        rows_page_option,
        freeze_header_table,
      };

      if (filter.length > 0) {
        const counter = {};
        filter.forEach((e) => {
          if (e.key) {
            counter[e.key.id] = (counter[e.key.id] || 0) + 1;
            if (counter[e.key.id] === 2) {
              params.export_view.filter[e.key.id] = [params.export_view.filter[e.key.id], e.value];
            } else if (counter[e.key.id] > 2) {
              const datas = params.export_view.filter[e.key.id];
              datas.push(e.value);
              params.export_view.filter[e.key.id] = datas;
            } else {
              params.export_view.filter[e.key.id] = e.value;
            }
          }
        });
      }

      if (filter_function.length > 0) {
        filter_function.forEach((e) => {
          if (e.key) {
            params.export_view.filter_function[e.key.id] = e.value;
          }
        });
      }
      return params;
    },

    isHaveConfiguration() {
      return !!this.formDetail.export_view;
    },

    isDatasetSource() {
      return this.formDetail.type === 'dataset';
    },
  },

  watch: {
    form_data_detail(val) {
      const detail = val && val[0];
      if (!this.formDetail.form_data_id || !detail || !detail.columns) return;

      this.setVariableOptions(detail.columns);

      if (this.formDetail.export_view) {
        const data = this._.cloneDeep(this.formDetail.export_view);
        const { title, sheet_name, format_file, columns, sheet, filter, filter_function, search_options_list, is_use_advance_report, rows_page_default, rows_page_option, freeze_header_table } = data;
        this.dataSetup.title = title;
        this.dataSetup.format_file = this.isDatasetSource
          ? 'csv'
          : (this.advanceReportSetting
            ? (is_use_advance_report
              ? 'csv'
              : (format_file !== ''
                ? format_file
                : null))
            : (format_file === 'csv'
              ? null
              : (format_file !== ''
                ? format_file
                : null)
            )
          );
        this.dataSetup.filterOperator = this.formDetail.export_view.filter_operator ?
          this.formDetail.export_view.filter_operator : null;
        this.dataSetup.search_options_list = search_options_list || [];
        this.dataSetup.is_use_advance_report = this.isDatasetSource ? true : (this.advanceReportSetting ? is_use_advance_report : false);
        this.dataSetup.rows_page_default = rows_page_default;
        this.dataSetup.rows_page_option = rows_page_option || [10, 20, 50, 100];
        this.dataSetup.freeze_header_table = freeze_header_table;

        if (sheet && sheet.length > 0) {
          this.dataSetup.sheet = sheet;
        } else if (!sheet || sheet.length === 0) {
          if (columns && columns.length > 0 && sheet_name) {
            const dataSheet = [
              {
                sheet_name,
                column_source: '',
                main_columns: columns.map(column => ({
                  name: column.name,
                  key: column.key,
                  type: column.type || 'text',
                  is_filter: column.is_filter,
                  content_alignment: column.content_alignment ? column.content_alignment : 'left',
                })),
                custom_class_columns: [],
              },
            ];
            this.dataSetup.sheet = dataSheet;
            this.dataSetup.sheet_name = '';
            this.dataSetup.columns = [];
          }
        }

        if (filter) {
          const keyFilter = Object.keys(filter);
          const valueFilter = Object.values(filter);
          if (keyFilter.length > 0) {
            this.dataSetup.filter = [];
            keyFilter.forEach((e, index) => {
              if (typeof valueFilter[index] === 'object') {
                valueFilter[index].forEach((v) => {
                  this.dataSetup.filter.push({
                    key: { id: e },
                    value: v,
                  });
                });
              } else {
                this.dataSetup.filter.push({
                  key: { id: e },
                  value: valueFilter[index],
                });
              }
            });
          }
        }

        if (filter_function) {
          const keyFilter = Object.keys(filter_function);
          const valueFilter = Object.values(filter_function);
          if (keyFilter.length > 0) {
            this.dataSetup.filter_function = [];
            keyFilter.forEach((e, index) => {
              this.dataSetup.filter_function.push({
                key: { id: e },
                value: valueFilter[index],
              });
            });
          }
        }
      } else {
        this.dataSetup = {
          title: null,
          sheet_name: '',
          format_file: this.isDatasetSource ? 'csv' : null,
          column: [],
          sheet: [],
          filter: [
            {
              key: null,
              value: null,
            },
          ],
          filter_function: [
            {
              key: null,
              value: null,
            },
          ],
          filterOperator: null,
          search_options_list: [],
          is_use_advance_report: !!this.isDatasetSource,
          rows_page_default: 10,
          rows_page_option: [10, 20, 50, 100],
          freeze_header_table: false,
        };
      }
    },

    formDetail(val) {
      if (!val.form_data_id) this.setExternalUrl();
    },

    // eslint-disable-next-line
    'dataSetup.title': function (val){
      setTimeout(() => {
        this.dataSetup.title = val.replace(' ', '_');
      }, 1);
    },

    // eslint-disable-next-line
    'dataSetup.is_use_advance_report': function (val) {
      if (!this.isLoading) {
        this.setChangesValueView(true);
        this.dataSetup.format_file = val ? 'csv' : null;
      }
    },

    showModalExternalApi(val) {
      if (val) {
        this.$refs.modalExternalApi.show();
        this.showModalExternalUrl = true;
      } else {
        this.$refs.modalExternalApi.hide();
        this.showModalExternalUrl = false;
      }
    },
  },

  async created() {
    if (this.formDetail.form_data_id) {
      const dataFilter = {
        id: [this.formDetail.form_data_id],
      };
      const param = {
        limit: 0,
        page: 1,
        filter: JSON.stringify(dataFilter),
      };
      await this.getDataAdvanceReport();
      await this.actionGetDetailFormData(param);
      const detail = this.form_data_detail[0];
      if (detail && detail.columns) this.createVariableOptionsSheet(detail.columns);
      this.isLoading = false;
    } else if (!this.formDetail.form_data_id) {
      if (this.isDatasetSource) {
        const req = {
          id: this.formDetail.data_source.dataset.dataset_id,
        };
        this.getDetailDatasetByGroup(req).then(async (res) => {
          this.detailDataset = res.data || null;
          await this.getDataAdvanceReport();
          await this.setExternalUrl();
          this.createVariableOptionsSheet(this.detailDataset.column);
          this.isLoading = false;
          this.setIsDataSet(true);
        });
      } else {
        await this.getDataAdvanceReport();
        await this.setExternalUrl();
        this.isLoading = false;
      }
    }
    this.getListFunction();
  },

  methods: {
    ...mapActions('jStoreFormUi', ['actionGetDetailForm', 'actionGetDetailMultiForm', 'actionSetForm', 'actionSetMultiForm', 'actionGetDetailFormData']),
    ...mapActions('jStoreAutomation', ['getDetailAutomation']),
    ...mapActions('jStoreNotificationScreen', ['toggleProblem']),
    ...mapMutations('jStoreFormUi', ['setChangesValueView']),
    ...mapMutations('jStoreExperienceManagerV2', [
      'setShowModalFieldLibrary', 'setIsShowModalFieldFromGroup', 'setSourceModalFieldLibrary', 'setTypeViewSearch', 'setIsDataSet',
    ]),
    ...mapActions('jStoreSetting', ['actionGetUserCompanySetting']),
    ...mapActions('jStoreJoana', ['getDetailDatasetByGroup']),

    getListFunction() {
      const dataFilter = {
        company_id: this.session.user.company_id,
      };
      dataFilter['trigger.type'] = 'function';
      const param = {
        limit: 1000000,
        page: 1,
        sort: { created_at: -1 },
        filter: JSON.stringify(dataFilter),
      };
      this.getDetailAutomation(param).then((res) => {
        this.listFunction = res.data.data.map(e => ({
          id: e.trigger.function ? e.trigger.function.name : '',
          name: e.trigger.function ? e.trigger.function.name : '',
        }));
      });
    },

    setExternalUrl() {
      if (this.isDatasetSource) {
        this.setVariableOptions(this.detailDataset.column);
      } else {
        this.setVariableOptions(this.formDetail.data_source.external_url.columns);
      }

      if (this.formDetail.export_view) {
        const data = JSON.parse(JSON.stringify(this.formDetail.export_view));
        const { title, sheet_name, format_file, columns, sheet, filter, filter_function, search_options_list, is_use_advance_report, rows_page_default, rows_page_option, freeze_header_table } = data;
        this.dataSetup.title = title;
        this.dataSetup.format_file = this.isDatasetSource
          ? 'csv'
          : (this.advanceReportSetting
            ? (is_use_advance_report
              ? 'csv'
              : (format_file !== ''
                ? format_file
                : null))
            : (format_file === 'csv'
              ? null
              : (format_file !== ''
                ? format_file
                : null)
            )
          );
        this.dataSetup.filterOperator = this.formDetail.export_view.filter_operator ?
          this.formDetail.export_view.filter_operator : null;
        this.dataSetup.search_options_list = search_options_list || [];
        this.dataSetup.is_use_advance_report = this.isDatasetSource ? true : (this.advanceReportSetting ? is_use_advance_report : false);
        this.dataSetup.sheet_name = sheet_name;
        this.dataSetup.rows_page_default = rows_page_default;
        this.dataSetup.rows_page_option = rows_page_option || [10, 20, 50, 100];
        this.dataSetup.freeze_header_table = freeze_header_table;

        if (this.isDatasetSource) {
          if (sheet && sheet.length > 0) {
            this.dataSetup.sheet = sheet;
          } else if (!sheet || sheet.length === 0) {
            if (columns && columns.length > 0 && sheet_name) {
              const dataSheet = [
                {
                  sheet_name,
                  column_source: '',
                  main_columns: columns.map(column => ({
                    name: column.name,
                    key: column.key,
                    type: column.type || 'text',
                    is_filter: column.is_filter,
                    content_alignment: column.content_alignment ? column.content_alignment : 'left',
                  })),
                  custom_class_columns: [],
                },
              ];
              this.dataSetup.sheet = dataSheet;
              this.dataSetup.sheet_name = '';
              this.dataSetup.columns = [];
            }
          }
        } else if (!this.isDatasetSource) {
          if (columns && columns.length > 0) {
            this.dataSetup.column = [];
            columns.forEach((column) => {
              this.dataSetup.column.push({
                name: column.name,
                key: column.key,
                type: column.type || 'text',
                is_filter: column.is_filter || false,
                content_alignment: column.content_alignment ? column.content_alignment : 'left',
                config: column.config || null,
              });
            });
          }
        }

        if (filter) {
          const keyFilter = Object.keys(filter);
          const valueFilter = Object.values(filter);
          if (keyFilter.length > 0) {
            this.dataSetup.filter = [];
            keyFilter.forEach((e, index) => {
              if (typeof valueFilter[index] === 'object') {
                valueFilter[index].forEach((v) => {
                  this.dataSetup.filter.push({
                    key: { id: e },
                    value: v,
                  });
                });
              } else {
                this.dataSetup.filter.push({
                  key: { id: e },
                  value: valueFilter[index],
                });
              }
            });
          }
        }

        if (filter_function) {
          const keyFilter = Object.keys(filter_function);
          const valueFilter = Object.values(filter_function);
          if (keyFilter.length > 0) {
            this.dataSetup.filter_function = [];
            keyFilter.forEach((e, index) => {
              this.dataSetup.filter_function.push({
                key: { id: e },
                value: valueFilter[index],
              });
            });
          }
        }
      } else {
        this.dataSetup = {
          title: null,
          sheet_name: '',
          format_file: this.isDatasetSource ? 'csv' : null,
          column: [],
          sheet: [],
          filter: [
            {
              key: null,
              value: null,
            },
          ],
          filter_function: [
            {
              key: null,
              value: null,
            },
          ],
          filterOperator: null,
          search_options_list: [],
          is_use_advance_report: !!this.isDatasetSource,
          rows_page_default: 10,
          rows_page_option: [10, 20, 50, 100],
          freeze_header_table: false,
        };
      }
    },

    async getDataAdvanceReport() {
      const { data, error } = await this.actionGetUserCompanySetting(false);
      if (!error) this.advanceReportSetting = !!data.advance_report;
    },

    closeModalFieldLibrary(data) {
      const element = document.getElementById(this.idModalFieldLibrary);
      if (element) element.classList.remove('show');

      if (this.isShowModalFieldFromGroup) {
        if (data) this.setSourceModalFieldLibrary(data);
      }

      setTimeout(() => {
        this.setShowModalFieldLibrary(false);
        this.setIsShowModalFieldFromGroup(false);
        this.setTypeViewSearch(null);
      }, 300);
    },

    openConfiguration() {
      this.isOpenConfiguration = true;
      this.toggleConfiguration(true);
    },

    toggleConfiguration(status) {
      if (status) {
        setTimeout(() => {
          const element = document.getElementById(this.idConfiguration);
          if (element) element.classList.add('show-properties-field');
        }, 200);
      } else {
        const element = document.getElementById(this.idConfiguration);
        if (element) element.classList.remove('show-properties-field');

        setTimeout(() => {
          this.isOpenConfiguration = false;
        }, 200);
      }
    },

    submitConfig(params) {
      this.dataSetup.title = params.title;
      this.dataSetup.filter = params.filter;
      this.dataSetup.filter_function = params.filter_function;
      this.dataSetup.filterOperator = params.filterOperator;
      this.dataSetup.search_options_list = params.search_options_list;
      this.dataSetup.rows_page_default = params.rows_page_default;
      this.dataSetup.rows_page_option = params.rows_page_option.filter(i => i !== '').map(i => Number(i));
      this.dataSetup.freeze_header_table = params.freeze_header_table;

      this.setChangesValueView(true);
      this.toggleConfiguration(false);
    },

    checkFirtsSheet(index) {
      if (index !== null) {
        if (index === 0) this.isFirstSheet = true;
        else this.isFirstSheet = false;
      } else if (index === null) {
        if (this.dataSetup.sheet.length > 0) this.isFirstSheet = false;
        else this.isFirstSheet = true;
      }
    },

    openConfigSheet(data, index) {
      if (this.isOpenSheetConfiguration) {
        this.toggleSheetConfiguration(false);

        setTimeout(() => {
          this.checkFirtsSheet(index);
          this.selectedSheet = data;
          this.selectedIndexSheet = index;
          this.toggleSheetConfiguration(true);
        }, 250);
      } else {
        this.checkFirtsSheet(index);
        this.selectedSheet = data;
        this.selectedIndexSheet = index;
        this.toggleSheetConfiguration(true);
      }
    },

    toggleSheetConfiguration(status) {
      if (status) {
        this.isOpenSheetConfiguration = true;

        setTimeout(() => {
          const element = document.getElementById(this.idConfigurationSheet);
          if (element) element.classList.add('show-properties-field');
        }, 200);
      } else {
        const element = document.getElementById(this.idConfigurationSheet);
        if (element) element.classList.remove('show-properties-field');

        setTimeout(() => {
          this.isOpenSheetConfiguration = false;
          this.selectedSheet = null;
          this.selectedIndexSheet = null;
          this.isFirstSheet = false;
        }, 200);
      }
    },

    submitSheet(mode, data) {
      if (mode === 'add') {
        this.dataSetup.sheet.push(data);
      } else {
        this.dataSetup.sheet[this.selectedIndexSheet] = data;
      }
      this.setChangesValueView(true);
      this.toggleSheetConfiguration(false);
    },

    deleteSheet(index) {
      this.$swal({
        title: 'Delete',
        text: 'Are you sure to delete this sheet?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        confirmButtonColor: '#D2232A',
        cancelButtonColor: '#D2232A',
        titleColor: '#D2232A',
      }).then(async (result) => {
        if (result.value) {
          this.dataSetup.sheet.splice(index || this.selectedIndexSheet, 1);
          this.setChangesValueView(true);
          this.toggleSheetConfiguration(false);
        }
      });
    },

    async submitForm() {
      this.$v.dataSetup.$touch();
      if (!this.$v.dataSetup.$error) {
        this.$swal({
          title: 'Update',
          text: `Are you sure to update ${this.formDetail.name}?`,
          type: 'question',
          showCancelButton: true,
          confirmButtonText: 'Update',
          confirmButtonColor: '#42a5ce',
          cancelButtonColor: '#D2232A',
          titleColor: '#D2232A',
        }).then(async (result) => {
          if (result.value) {
            let res;
            if (!this.isMultipleForm) {
              res = await this.actionSetForm(this.genData);
            } else {
              res = await this.actionSetMultiForm(this.genData);
            }
            if (!res.error) {
              this.setChangesValueView(false);
              const dataFilter = {
                id: [this.$route.params.id],
              };
              const param = {
                limit: 0,
                page: 1,
                filter: JSON.stringify(dataFilter),
              };
              if (!this.isMultipleForm) {
                await this.actionGetDetailForm(param);
              } else {
                await this.actionGetDetailMultiForm(param);
              }
            }
          }
        });
      } else {
        this.toggleProblem('Please input Title field');
      }
    },

    async deleteView() {
      this.$swal({
        title: 'Delete',
        text: 'Are you sure to delete this view?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        confirmButtonColor: '#D2232A',
        cancelButtonColor: '#D2232A',
        titleColor: '#D2232A',
      }).then(async (result) => {
        if (result.value) {
          const params = this._.cloneDeep(this.formDetail);
          params.export_view = null;
          let res;
          if (!this.isMultipleForm) {
            res = await this.actionSetForm(params);
          } else {
            res = await this.actionSetMultiForm(params);
          }
          if (!res.error) {
            this.setChangesValueView(false);
            const dataFilter = {
              id: [this.$route.params.id],
            };
            const param = {
              limit: 0,
              page: 1,
              filter: JSON.stringify(dataFilter),
            };
            if (!this.isMultipleForm) {
              await this.actionGetDetailForm(param);
            } else {
              await this.actionGetDetailMultiForm(param);
            }
            this.toggleConfiguration(false);
          }
        }
      });
    },

    setVariableOptions(columns) {
      const listColumns = Object.keys(columns);
      const listColumnsVal = Object.values(columns);

      this.variableOptions = [];
      this.variableOptionsClass = [];
      this.variableOptionsColumn = [];

      if (this.isExternalApi) {
        if (listColumns.length > 0) {
          listColumns.forEach((column, index) => {
            this.variableOptionsClass.push({
              id: column,
              label: column,
              text: column,
              type: listColumnsVal[index].type,
            });
            this.variableOptionsColumn.push({
              id: column,
              label: column,
              text: column,
              type: listColumnsVal[index].type,
            });
            this.variableOptions.push({
              id: column,
              label: column,
              text: column,
              type: listColumnsVal[index].type,
            });
          });
        }
      } else if (!this.isExternalApi) {
        if (listColumns.length > 0) {
          listColumns.forEach((column, index) => {
            if (listColumnsVal[index].type !== '[]attachment') {
              this.variableOptions.push({
                id: column,
                label: column,
                text: column,
                type: listColumnsVal[index].type,
              });

              if (listColumnsVal[index].type === 'person') {
                this.variableOptionsClass.push({
                  id: `${column}.company_user_id`,
                  label: `${column}.company_user_id`,
                  text: `${column}.company_user_id`,
                  type: listColumnsVal[index].type,
                });
                this.variableOptionsColumn.push({
                  id: `${column}.company_user_id`,
                  label: `${column}.company_user_id`,
                  text: `${column}.company_user_id`,
                  type: listColumnsVal[index].type,
                });
                this.variableOptionsClass.push({
                  id: `${column}.name`,
                  label: `${column}.name`,
                  text: `${column}.name`,
                  type: listColumnsVal[index].type,
                });
                this.variableOptionsColumn.push({
                  id: `${column}.name`,
                  label: `${column}.name`,
                  text: `${column}.name`,
                  type: listColumnsVal[index].type,
                });
                this.variableOptionsClass.push({
                  id: `${column}.email`,
                  label: `${column}.email`,
                  text: `${column}.email`,
                  type: listColumnsVal[index].type,
                });
                this.variableOptionsColumn.push({
                  id: `${column}.email`,
                  label: `${column}.email`,
                  text: `${column}.email`,
                  type: listColumnsVal[index].type,
                });
              } else if (listColumnsVal[index].type === 'object') {
                this.variableOptionsClass.push({
                  id: `${column}.id`,
                  label: `${column}.id`,
                  text: `${column}.id`,
                  type: listColumnsVal[index].type,
                });
                this.variableOptionsColumn.push({
                  id: `${column}.id`,
                  label: `${column}.id`,
                  text: `${column}.id`,
                  type: listColumnsVal[index].type,
                });
                this.variableOptionsClass.push({
                  id: `${column}.name`,
                  label: `${column}.name`,
                  text: `${column}.name`,
                  type: listColumnsVal[index].type,
                });
                this.variableOptionsColumn.push({
                  id: `${column}.name`,
                  label: `${column}.name`,
                  text: `${column}.name`,
                  type: listColumnsVal[index].type,
                });
              } else if (listColumnsVal[index].type === 'timer') {
                this.variableOptionsClass.push({
                  id: `${column}.state`,
                  label: `${column}.state`,
                  text: `${column}.state`,
                  type: listColumnsVal[index].type,
                });
                this.variableOptionsClass.push({
                  id: `${column}.duration`,
                  label: `${column}.duration`,
                  text: `${column}.duration`,
                  type: listColumnsVal[index].type,
                });
              } else if (listColumnsVal[index].type === 'tags') {
                this.variableOptionsClass.push({
                  id: `${column}.name`,
                  label: `${column}.name`,
                  text: `${column}.name`,
                  type: listColumnsVal[index].type,
                });
                this.variableOptionsColumn.push({
                  id: `${column}.name`,
                  label: `${column}.name`,
                  text: `${column}.name`,
                  type: listColumnsVal[index].type,
                });
                this.variableOptionsClass.push({
                  id: `${column}.background`,
                  label: `${column}.background`,
                  text: `${column}.background`,
                  type: listColumnsVal[index].type,
                });
                this.variableOptionsColumn.push({
                  id: `${column}.background`,
                  label: `${column}.background`,
                  text: `${column}.background`,
                  type: listColumnsVal[index].type,
                });
                this.variableOptionsClass.push({
                  id: `${column}.font_color`,
                  label: `${column}.font_color`,
                  text: `${column}.font_color`,
                  type: listColumnsVal[index].type,
                });
                this.variableOptionsColumn.push({
                  id: `${column}.font_color`,
                  label: `${column}.font_color`,
                  text: `${column}.font_color`,
                  type: listColumnsVal[index].type,
                });
              } else if (listColumnsVal[index].type === 'maps') {
                this.variableOptionsClass.push({
                  id: `${column}.latitude`,
                  label: `${column}.latitude`,
                  text: `${column}.latitude`,
                  type: listColumnsVal[index].type,
                });
                this.variableOptionsColumn.push({
                  id: `${column}.latitude`,
                  label: `${column}.latitude`,
                  text: `${column}.latitude`,
                  type: listColumnsVal[index].type,
                });
                this.variableOptionsClass.push({
                  id: `${column}.longitude`,
                  label: `${column}.longitude`,
                  text: `${column}.longitude`,
                  type: listColumnsVal[index].type,
                });
                this.variableOptionsColumn.push({
                  id: `${column}.longitude`,
                  label: `${column}.longitude`,
                  text: `${column}.longitude`,
                  type: listColumnsVal[index].type,
                });
                this.variableOptionsClass.push({
                  id: `${column}.address`,
                  label: `${column}.address`,
                  text: `${column}.address`,
                  type: listColumnsVal[index].type,
                });
                this.variableOptionsColumn.push({
                  id: `${column}.address`,
                  label: `${column}.address`,
                  text: `${column}.address`,
                  type: listColumnsVal[index].type,
                });
              } else {
                this.variableOptionsClass.push({
                  id: column,
                  label: column,
                  text: column,
                  type: listColumnsVal[index].type,
                });
                this.variableOptionsColumn.push({
                  id: column,
                  label: column,
                  text: column,
                  type: listColumnsVal[index].type,
                });
              }
            }
          });
        }
      }
    },

    createVariableOptionsSheet(columns) {
      const listColumns = Object.keys(columns);
      const listColumnsVal = Object.values(columns);

      this.variableOptionsSheet = [];
      this.variableCustomOptions = [];

      if (listColumns.length > 0) {
        listColumns.forEach((column, index) => {
          const type = listColumnsVal[index].type;
          const name = listColumnsVal[index].name;

          if (type.includes('[]')) {
            if (
              type === '[]attachment' || type === '[]text' || type === '[]number' ||
              type === '[]object' || type === '[]tags' || type === '[]text'
            ) {
              this.variableOptionsSheet.push({
                id: column,
                label: column,
                text: column,
              });
            } else {
              const detail = this.form_data_detail[0];
              this.variableCustomOptions.push({
                id: column,
                label: column,
                text: column,
                class: this.createChildVariableCustom((detail && detail.class && detail.class[name]) || {}),
              });
            }
          } else if (!type.includes('[]')) {
            if (type === 'person') {
              this.variableOptionsSheet.push({
                id: `${column}.company_user_id`,
                label: `${column}.company_user_id`,
                text: `${column}.company_user_id`,
                type: listColumnsVal[index].type,
              });
              this.variableOptionsSheet.push({
                id: `${column}.name`,
                label: `${column}.name`,
                text: `${column}.name`,
                type: listColumnsVal[index].type,
              });
              this.variableOptionsSheet.push({
                id: `${column}.email`,
                label: `${column}.email`,
                text: `${column}.email`,
                type: listColumnsVal[index].type,
              });
            } else if (type === 'object') {
              this.variableOptionsSheet.push({
                id: `${column}.id`,
                label: `${column}.id`,
                text: `${column}.id`,
                type: listColumnsVal[index].type,
              });
              this.variableOptionsSheet.push({
                id: `${column}.name`,
                label: `${column}.name`,
                text: `${column}.name`,
                type: listColumnsVal[index].type,
              });
            } else if (type === 'timer') {
              this.variableOptionsSheet.push({
                id: `${column}.state`,
                label: `${column}.state`,
                text: `${column}.state`,
                type: listColumnsVal[index].type,
              });
              this.variableOptionsSheet.push({
                id: `${column}.duration`,
                label: `${column}.duration`,
                text: `${column}.duration`,
                type: listColumnsVal[index].type,
              });
            } else if (type === 'tags') {
              this.variableOptionsSheet.push({
                id: `${column}.name`,
                label: `${column}.name`,
                text: `${column}.name`,
                type: listColumnsVal[index].type,
              });
              this.variableOptionsSheet.push({
                id: `${column}.background`,
                label: `${column}.background`,
                text: `${column}.background`,
                type: listColumnsVal[index].type,
              });
              this.variableOptionsSheet.push({
                id: `${column}.font_color`,
                label: `${column}.font_color`,
                text: `${column}.font_color`,
                type: listColumnsVal[index].type,
              });
            } else if (type === 'maps') {
              this.variableOptionsSheet.push({
                id: `${column}.latitude`,
                label: `${column}.latitude`,
                text: `${column}.latitude`,
                type: listColumnsVal[index].type,
              });
              this.variableOptionsSheet.push({
                id: `${column}.longitude`,
                label: `${column}.longitude`,
                text: `${column}.longitude`,
                type: listColumnsVal[index].type,
              });
              this.variableOptionsSheet.push({
                id: `${column}.address`,
                label: `${column}.address`,
                text: `${column}.address`,
                type: listColumnsVal[index].type,
              });
            } else {
              this.variableOptionsSheet.push({
                id: column,
                label: column,
                text: column,
                type: listColumnsVal[index].type,
              });
            }
          }
        });
      }
    },

    createChildVariableCustom(dataClass) {
      const listColumns = Object.keys(dataClass);
      const listColumnsVal = Object.values(dataClass);

      const childClass = [];

      if (listColumns.length > 0) {
        listColumns.forEach((column, index) => {
          const type = listColumnsVal[index].type;

          if (type.includes('[]')) {
            childClass.push({
              id: column,
              label: column,
              text: column,
              type: listColumnsVal[index].type,
            });
          } else if (!type.includes('[]')) {
            if (type === 'person') {
              childClass.push({
                id: `${column}.company_user_id`,
                label: `${column}.company_user_id`,
                text: `${column}.company_user_id`,
                type: listColumnsVal[index].type,
              });
              childClass.push({
                id: `${column}.name`,
                label: `${column}.name`,
                text: `${column}.name`,
                type: listColumnsVal[index].type,
              });
              childClass.push({
                id: `${column}.email`,
                label: `${column}.email`,
                text: `${column}.email`,
                type: listColumnsVal[index].type,
              });
            } else if (type === 'object') {
              childClass.push({
                id: `${column}.id`,
                label: `${column}.id`,
                text: `${column}.id`,
                type: listColumnsVal[index].type,
              });
              childClass.push({
                id: `${column}.name`,
                label: `${column}.name`,
                text: `${column}.name`,
                type: listColumnsVal[index].type,
              });
            } else if (type === 'timer') {
              childClass.push({
                id: `${column}.state`,
                label: `${column}.state`,
                text: `${column}.state`,
                type: listColumnsVal[index].type,
              });
              childClass.push({
                id: `${column}.duration`,
                label: `${column}.duration`,
                text: `${column}.duration`,
                type: listColumnsVal[index].type,
              });
            } else if (type === 'tags') {
              childClass.push({
                id: `${column}.name`,
                label: `${column}.name`,
                text: `${column}.name`,
                type: listColumnsVal[index].type,
              });
              childClass.push({
                id: `${column}.background`,
                label: `${column}.background`,
                text: `${column}.background`,
                type: listColumnsVal[index].type,
              });
              childClass.push({
                id: `${column}.font_color`,
                label: `${column}.font_color`,
                text: `${column}.font_color`,
                type: listColumnsVal[index].type,
              });
            } else if (type === 'maps') {
              childClass.push({
                id: `${column}.latitude`,
                label: `${column}.latitude`,
                text: `${column}.latitude`,
                type: listColumnsVal[index].type,
              });
              childClass.push({
                id: `${column}.longitude`,
                label: `${column}.longitude`,
                text: `${column}.longitude`,
                type: listColumnsVal[index].type,
              });
              childClass.push({
                id: `${column}.address`,
                label: `${column}.address`,
                text: `${column}.address`,
                type: listColumnsVal[index].type,
              });
            } else {
              childClass.push({
                id: column,
                label: column,
                text: column,
                type: listColumnsVal[index].type,
              });
            }
          }
        });
      }
      return childClass;
    },
  },

  validations() {
    return {
      dataSetup: {
        title: { required },
        description: {},
        sheet_name: {},
        format_file: {},
        column: {},
        filter: {},
        filter_function: {},
        filterOperator: {},
        search_options_list: {},
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/experience-manager-v2/menu/jExportView.vue